import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '../components/date-picker.component';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    DatePickerComponent,
 
  ],
  imports:[
    CommonModule,
    FormsModule ,
    NgbDatepickerModule

  ],
  exports:[
    DatePickerComponent,
    NgbDatepickerModule
  ]
})
export class DatePickerModule { }
